import { Slide } from "@jelly/lesson";
import config from "appConfig";
import theory from "../../theory";

const principle: Slide = {
  description:
    "This example illustrate real-time convolution which usually works block-wize. The upper signal is a block from an audio stream, and the lower is a filter impulse response which should be convolved with the audio stream. Please listen to the examples by clicking on the loudspeaker icons.",
  theory: theory,
  layout: {
    type: "table",
    options: {
      cols: 4,
      rows: 4,
      rowsSize: [1, 4, 1, 4],
      colsSize: [1, 2, 3, 3],
      colSpan: {
        "1:0": 4,
        "3:0": 4,
      },
      components: [
        [
          null,
          {
            variant: "blockContainer",
            data: {
              block: {
                type: "text",
                options: {
                  formatter: "html",
                  data: "<b>Block from audio stream</b>",
                  scrollbars: false,
                },
              },
              styles: {
                justifyContent: "flex-start",
              },
            },
          },
          {
            variant: "blockContainer",
            data: {
              block: {
                type: "audioButton",
                options: {
                  url: `${config.ASSETS_URL}/03/18/principle/slide-01-audio-stream.wav`,
                  text: "play sound",
                  icon: "cis-volume-high",
                  theme: "secondary",
                  shape: "round",
                  size: "large",
                },
              },
            },
          },
        ],
        [
          {
            variant: "blockContainer",
            data: {
              block: {
                type: "image",
                options: {
                  src: `${config.ASSETS_URL}/03/18/principle/slide-01-audio-stream.svg`,
                },
              },
              styles: {
                padding: "0 5%",
              },
            },
          },
        ],
        [
          null,
          {
            variant: "blockContainer",
            data: {
              block: {
                type: "text",
                options: {
                  formatter: "html",
                  data: "<b>Filter signal</b>",
                  scrollbars: false,
                },
              },
              styles: {
                justifyContent: "flex-start",
              },
            },
          },
          {
            variant: "blockContainer",
            data: {
              block: {
                type: "audioButton",
                options: {
                  url: `${config.ASSETS_URL}/03/18/principle/slide-01-filter-signal.wav`,
                  text: "play sound",
                  icon: "cis-volume-high",
                  theme: "secondary",
                  shape: "round",
                  size: "large",
                },
              },
            },
          },
        ],
        [
          {
            variant: "blockContainer",
            data: {
              block: {
                type: "image",
                options: {
                  src: `${config.ASSETS_URL}/03/18/principle/slide-01-filter-signal.svg`,
                },
              },
              styles: {
                padding: "0 5%",
              },
            },
          },
        ],
      ],
    },
  },
};

export default principle;
